import { string } from './utils';

export interface Media {
  id?: string;
  url: string;
}

export function isMedia(data?: any): data is Media {
  if (!data || typeof data !== 'object') return false;
  return string(data.url);
}
